module.exports = __webpack_public_path__ + "media/svg/jm-6b490554.svg";